import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MenuProps, notification } from 'antd';
import { downloadFile } from 'helpers/download';
import { getMenuItemNavigationUrl, getNavbarMenuItemColor, getNavbarMenuItemIcon } from 'helpers/menu-helpers';
import { MenuItem } from 'pages/home/models/types/home';
import { downloadRapportage, RapportageDownloadRequest } from 'pages/rapportage/models/rapportage';
import { NavigateFunction } from 'react-router';
import styles from './main-menu.module.scss';

export const getInternalMenuPath = (menuUrl: string, kringloopwijzerId: string | null): string => {
  const parsedUrl = new URL(menuUrl, window.location.origin);
  const path = parsedUrl.pathname.replace(/\/$/, '');
  return `${path}/${kringloopwijzerId ?? ''}${parsedUrl.search}${parsedUrl.hash}`;
};

export const getMenuItemChild = (menuItem: MenuItem, nav: NavigateFunction, closeMenu: () => void, incompleetDisabled: boolean = false) => {
  const onClick = (menuItem: MenuItem) => {
    if (menuItem.titel === 'KLW Resultaten Volledig') {
      getRapportage(5);
    } else if (menuItem.titel === 'BEX rapportage') {
      getRapportage(99);
    } else {
      nav(getMenuItemNavigationUrl(menuItem.url, localStorage.getItem('KringloopwijzerId')));
    }
    closeMenu();
  };

  const getRapportage = (rapportageType: number) => {
    // TODO; refactor request model once frontend is fully moved to React, Callcontext KLW id is being used and is present in header
    var request: RapportageDownloadRequest = { kringloopwijzerId: 0, rapportageTypeId: rapportageType };
    downloadNotifications('Uw rapport wordt gegenereerd', '', 'info', 0);
    downloadRapportage(request)
      .then(response => {
        response.rapporten.forEach(rapport => {
          downloadFile(rapport.file, rapport.naam, rapport.mimeType);
        });
        downloadNotifications('Succesvol rapportage opgehaald', 'Rapportages zijn gedownload', 'success', 5);
      })
      .catch(error => {
        downloadNotifications('Het rapport kan niet samengesteld worden. Raadpleeg uw signaleringen.', '', 'error', 5);
      });
  };

  const downloadNotifications = (message: string, description: string, type: string, duration: number) => {
    let descr = description ?? message;
    const key = 'rapportageDownload';

    notification[type]({
      key,
      message: message,
      description: descr,
      duration: duration,
    });
  };

  const item: NonNullable<MenuProps['items']>[number] = {
    icon: <FontAwesomeIcon className={styles.iconSmall} style={{ color: getNavbarMenuItemColor(menuItem) }} icon={getNavbarMenuItemIcon(menuItem)} />,
    label: <span style={{ color: getNavbarMenuItemColor(menuItem) }}>{menuItem.titel}</span>,
    onClick: () => onClick(menuItem),
    disabled: !menuItem.isGereed && incompleetDisabled,
    key: menuItem.titel,
  };
  return item;
};
